export default __webpack_public_path__ + "static/zach-bitmoji-0f7ca7f5c8bba8aaa0dc25f3e2dfeb77.png";